/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./base/containers/base-container/base-container.component.ngfactory";
import * as i3 from "./base/containers/base-container/base-container.component";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/router";
import * as i6 from "@ngx-translate/core";
import * as i7 from "./core/services/page-routing.service";
import * as i8 from "./core/services/crash.service";
import * as i9 from "./app.component";
import * as i10 from "@angular/common";
import * as i11 from "./shared/services/tenant.service";
import * as i12 from "./shared/services/analytics.service";
var styles_AppComponent = [i0.styles];
var RenderType_AppComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AppComponent, data: {} });
export { RenderType_AppComponent as RenderType_AppComponent };
export function View_AppComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "app-base-container", [], null, null, null, i2.View_BaseContainer_0, i2.RenderType_BaseContainer)), i1.ɵdid(1, 114688, null, 0, i3.BaseContainer, [i4.Store, i5.Router, i6.TranslateService, i1.ViewContainerRef, i7.PageRoutingService, i8.CrashService], null, null), (_l()(), i1.ɵeld(2, 0, null, null, 0, "link", [["id", "customCss"], ["rel", "stylesheet"]], null, [[null, "load"], [null, "error"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("load" === en)) {
        var pd_0 = (_co.onCssSuccess() !== false);
        ad = (pd_0 && ad);
    } if (("error" === en)) {
        var pd_1 = (_co.onCssError() !== false);
        ad = (pd_1 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵeld(3, 0, null, null, 0, "div", [["class", "overlay"], ["id", "overlay"]], null, null, null, null, null))], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_AppComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-root", [], null, [["window", "scroll"]], function (_v, en, $event) { var ad = true; if (("window:scroll" === en)) {
        var pd_0 = (i1.ɵnov(_v, 1).onWindowScroll() !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_AppComponent_0, RenderType_AppComponent)), i1.ɵdid(1, 114688, null, 0, i9.AppComponent, [i5.Router, i10.Location, i11.TenantService, i12.AnalyticsService, i1.PLATFORM_ID, i4.Store, i10.DOCUMENT], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AppComponentNgFactory = i1.ɵccf("app-root", i9.AppComponent, View_AppComponent_Host_0, {}, {}, []);
export { AppComponentNgFactory as AppComponentNgFactory };
